import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=422336f4&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=ts&"
export * from "./EmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=422336f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422336f4",
  null
  
)

export default component.exports